(() => {
  'use strict';
  const q = (s, el = document) => el.querySelector(s);
  const qa = (s, el = document) => [...el.querySelectorAll(s)];
  const root = window.KP?.root || '/';
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.KP?.currency || 'USD' }).format(cents / 100);
  const unitMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.KP?.currency || 'USD', minimumFractionDigits: cents < 10 ? 3 : 2, maximumFractionDigits: cents < 10 ? 3 : 2 }).format(cents / 100);
  const parse = (node) => { try { return JSON.parse(node?.textContent || '{}'); } catch { return {}; } };
  const media = parse(q('#kp-media-map'));
  const node = (tag, text, className) => { const e = document.createElement(tag); if (text != null) e.textContent = text; if (className) e.className = className; return e; };
  const syncLock = () => document.body.classList.toggle('kp-dialog-open', !!q('dialog[open]'));
  function openDialog(id) {
    const dialog = document.getElementById(id);
    if (!dialog) return;
    qa('dialog[open]').forEach(d => { if (d !== dialog && d.id !== 'kp-age') d.close(); });
    if (!dialog.open) dialog.showModal();
    syncLock();
  }
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-open]');
    if (opener && document.getElementById(opener.dataset.open)) { e.preventDefault(); openDialog(opener.dataset.open); }
    const menuLink = e.target.closest('#kp-menu a');
    if (menuLink) menuLink.closest('dialog')?.close();
    const closer = e.target.closest('[data-close]');
    if (closer) closer.closest('dialog')?.close();
    if (!e.target.closest('.kp-nav details') || e.target.closest('.kp-nav details a')) qa('.kp-nav details[open]').forEach(d => d.open = false);
  });
  qa('dialog').forEach(dialog => {
    dialog.addEventListener('close', syncLock);
    dialog.addEventListener('click', e => {
      if (e.target !== dialog || dialog.id === 'kp-age') return;
      const r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
    });
  });
  qa('.kp-nav details').forEach(d => d.addEventListener('toggle', () => { if (d.open) qa('.kp-nav details').filter(other => other !== d).forEach(other => other.open = false); }));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') qa('.kp-nav details[open]').forEach(d => d.open = false); });

  const age = q('#kp-age');
  if (age) {
    let verified = document.cookie.split(';').some(c => c.trim() === 'age-verified=true');
    try { verified ||= localStorage.getItem('age-verified') === 'true'; } catch { /* Cookie remains available if storage is blocked. */ }
    if (!verified && !window.Shopify?.designMode) openDialog('kp-age');
    age.addEventListener('cancel', e => e.preventDefault());
    q('[data-verify-age]', age)?.addEventListener('click', () => {
      try { localStorage.setItem('age-verified', 'true'); } catch { /* Use the cookie when local storage is unavailable. */ }
      document.cookie = 'age-verified=true; path=/; max-age=34560000; SameSite=Lax; Secure';
      age.close();
    });
  }
  qa('[data-auto-submit]').forEach(input => input.addEventListener('change', () => input.form.requestSubmit()));

  const search = q('[data-predictive-input]');
  const suggestions = q('[data-search-suggestions]');
  let searchTimer, searchRequest;
  search?.addEventListener('input', () => {
    clearTimeout(searchTimer); searchRequest?.abort();
    const term = search.value.trim();
    if (term.length < 2) { suggestions.replaceChildren(); return; }
    searchTimer = setTimeout(async () => {
      searchRequest = new AbortController();
      try {
        const params = new URLSearchParams({ q: term, 'resources[type]': 'product,page,article', 'resources[limit]': '5', 'resources[options][unavailable_products]': 'last' });
        const response = await fetch(`${root}search/suggest.json?${params}`, { signal: searchRequest.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const results = (await response.json()).resources?.results || {};
        const products = (results.products || []).slice(0, 4);
        if (search.value.trim() !== term) return;
        suggestions.replaceChildren();
        if (products.length) suggestions.append(node('p', 'PRODUCTS', 'kp-search-group'));
        products.forEach(product => {
          const link = node('a', null, 'kp-search-suggestion'); link.href = product.url;
          const img = node('img'); img.src = media[product.handle] || product.featured_image?.url || product.image; img.alt = ''; img.width = 64; img.height = 64; img.dataset.kpImageHandle = product.handle; img.dataset.kpImageIndex = '1';
          const text = node('span'); text.append(node('strong', product.title));
          if (product.price != null) text.append(node('small', money(Number(product.price) * 100)));
          link.append(img, text); suggestions.append(link);
        });
        const guides = [...(results.pages || []), ...(results.articles || [])].slice(0, 4);
        if (guides.length) suggestions.append(node('p', 'GUIDES & INFORMATION', 'kp-search-group'));
        guides.forEach(guide => { const link = node('a', guide.title + ' ↗', 'kp-search-guide'); link.href = guide.url; suggestions.append(link); });
        const all = node('a', products.length ? `View all results for “${term}” →` : `Search all pages for “${term}” →`, 'kp-text-link');
        all.href = `${root}search?q=${encodeURIComponent(term)}`; suggestions.append(all);
      } catch (error) { if (error.name !== 'AbortError') suggestions.replaceChildren(node('p', 'Press Enter to search the store.')); }
    }, 220);
  });

  let cartBusy = false;
  async function refreshCart() {
    const response = await fetch(`${root}cart?section_id=kp-cart-panel`, { cache: 'no-store' });
    if (!response.ok) throw new Error('Please open your bag to see the latest update.');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const content = q('[data-cart-content]', html);
    if (!content) throw new Error('Please refresh the page to see your updated bag.');
    qa('[data-cart-body], #KpCartPage').forEach((target, index) => {
      const copy = content.cloneNode(true);
      qa('[id]', copy).forEach(e => { const old = e.id; e.id = `cart-${index}-${old}`; qa('label', copy).filter(l => l.htmlFor === old).forEach(l => l.htmlFor = e.id); });
      const previous = q('[data-cart-content]', target);
      if (previous) previous.replaceWith(copy); else target.append(copy);
    });
    qa('[data-cart-count]').forEach(e => e.textContent = content.dataset.itemCount);
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }
  async function changeCart(key, quantity) {
    if (cartBusy) return;
    cartBusy = true;
    qa('[data-cart-quantity], [name="checkout"]').forEach(e => e.disabled = true);
    try {
      const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'We could not update your bag. Please try again.');
      await refreshCart();
    } catch (error) {
      qa('[data-cart-error]').forEach(e => { e.textContent = error.message; e.hidden = false; });
    } finally {
      cartBusy = false;
      qa('[data-cart-quantity], [name="checkout"]').forEach(e => e.disabled = false);
    }
  }
  document.addEventListener('click', e => {
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); changeCart(remove.dataset.cartRemove, 0); }
  });
  document.addEventListener('change', e => {
    if (e.target.matches('[data-cart-quantity]')) {
      const max = e.target.max ? Number(e.target.max) : Infinity;
      const quantity = Math.min(max, Math.max(0, Math.floor(Number(e.target.value) || 0)));
      e.target.value = quantity;
      changeCart(e.target.dataset.cartQuantity, quantity);
    }
  });

  function units(variant, handle) {
    const options = variant.options || [];
    if (handle.includes('capsule')) {
      const count = options.map(o => o.match(/^([\d,]+)\s*(?:capsules?|count|\()/i)).find(Boolean);
      if (count) return { count: Number(count[1].replaceAll(',', '')), unit: 'capsule' };
    }
    if (handle.includes('tablet')) {
      const count = options.map(o => o.match(/^([\d,]+)\s*tablets?/i)).find(Boolean);
      if (count) return { count: Number(count[1].replaceAll(',', '')), unit: 'tablet' };
    }
    const weight = options.map(o => o.match(/^([\d,.]+)\s*(kg|g)(?:\s|$)/i)).find(Boolean);
    return weight ? { count: Number(weight[1].replaceAll(',', '')) * (weight[2].toLowerCase() === 'kg' ? 1000 : 1), unit: 'g' } : null;
  }
  qa('[data-address-country]').forEach(country => {
    const form = country.closest('form');
    const province = q('[data-address-province]', form);
    if (country.dataset.default) country.value = country.dataset.default;
    function updateProvinces(initial) {
      let options = []; try { options = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch { /* No regional options. */ }
      province.replaceChildren(...options.map(([value, label]) => { const option = node('option', label); option.value = value; return option; }));
      q('[data-province-field]', form).hidden = !options.length;
      if (initial && province.dataset.default) province.value = province.dataset.default;
    }
    country.addEventListener('change', () => updateProvinces(false)); updateProvinces(true);
  });
  const productRoot = q('[data-product-root]');
  if (productRoot) {
    const product = parse(q('[data-product-json]', productRoot));
    const form = q('[data-product-form]', productRoot);
    const variantSelect = q('[data-variant-id]', form);
    const add = q('[data-add-button]', form);
    const sticky = q('[data-sticky-buy]', productRoot);
    const stickyAdd = q('[data-sticky-add]', productRoot);
    let selected = product.variants.find(v => String(v.id) === variantSelect.value) || product.variants[0];
    let adding = false;
    const currentOptions = () => (product.options || []).map((_, i) => q(`[data-option-index="${i}"] input:checked`, form)?.value || q(`[data-fixed-option="${i}"]`, form)?.value || selected?.options[i]);
    function choose(variant, updateURL = true) {
      selected = variant;
      const valid = !!variant?.available;
      add.disabled = !valid || adding; stickyAdd.disabled = !valid || adding;
      add.firstChild.textContent = valid ? 'Add to bag ' : variant ? 'Sold out ' : 'Unavailable ';
      if (!variant) return;
      variantSelect.value = variant.id;
      q('[data-product-price]', productRoot).textContent = money(variant.price);
      const compare = q('[data-product-compare]', productRoot); compare.textContent = money(variant.compare_at_price || 0); compare.hidden = !(variant.compare_at_price > variant.price);
      const unit = units(variant, product.handle);
      const unitPrice = q('[data-unit-price]', productRoot); unitPrice.textContent = unit ? `${unitMoney(variant.price / unit.count)} / ${unit.unit}` : ''; unitPrice.hidden = !unit;
      q('[data-sticky-price]', productRoot).textContent = money(variant.price);
      q('[data-sticky-variant]', productRoot).textContent = variant.title === 'Default Title' ? '' : variant.title;
      qa('[data-option-index]', form).forEach(field => {
        const index = Number(field.dataset.optionIndex);
        q('[data-option-selection]', field).textContent = variant.options[index];
        qa('input', field).forEach(input => {
          input.checked = input.value === variant.options[index];
          input.disabled = !product.variants.some(v => v.available && v.options.every((value, i) => i === index ? value === input.value : value === variant.options[i]));
        });
      });
      qa('[data-price-variant]').forEach(row => { row.classList.toggle('is-selected', row.dataset.priceVariant === String(variant.id)); if (product.handle === 'bulk-kratom-capsules') row.hidden = row.dataset.priceStrain !== variant.options[0]; });
      if (updateURL) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
    }
    form.addEventListener('change', e => {
      if (!e.target.closest('[data-option-index]')) return;
      q('[data-product-error]', form).hidden = true;
      const options = currentOptions();
      choose(product.variants.find(v => v.options.every((value, index) => value === options[index])));
    });
    qa('[data-quantity-step]', form).forEach(button => button.addEventListener('click', () => {
      const input = q('[name="quantity"]', form);
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(button.dataset.quantityStep));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    qa('[data-image-index]', productRoot).forEach(button => button.addEventListener('click', () => {
      const img = q('img', button);
      qa('.kp-gallery__image, .kp-zoom-image', productRoot).forEach(target => { target.src = img.src; target.alt = img.alt; target.dataset.kpImageIndex = button.dataset.imageIndex; target.removeAttribute('srcset'); });
      qa('[data-image-index]', productRoot).forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }));
    form.addEventListener('submit', async e => {
      e.preventDefault(); if (adding || !selected?.available || !form.reportValidity()) return;
      adding = true; add.disabled = true; stickyAdd.disabled = true; add.firstChild.textContent = 'Adding… ';
      const error = q('[data-product-error]', form); error.hidden = true;
      try {
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'We could not add this item. Please try again.');
        try { await refreshCart(); openDialog('kp-cart'); } catch { location.assign(`${root}cart`); }
      } catch (err) { error.textContent = err.message; error.hidden = false; }
      finally { adding = false; choose(selected, false); }
    });
    stickyAdd.addEventListener('click', () => form.requestSubmit());
    const observeSticky = () => { const visible = add.getBoundingClientRect().bottom < 0 && (q('.kp-newsletter')?.getBoundingClientRect().top || Infinity) > innerHeight; sticky.classList.toggle('is-visible', visible); sticky.inert = !visible; sticky.setAttribute('aria-hidden', String(!visible)); };
    window.addEventListener('scroll', observeSticky, { passive: true });
    window.addEventListener('resize', observeSticky);

    const table = q('[data-price-guide-body]');
    if (table) {
      product.variants.forEach(variant => {
        const unit = units(variant, product.handle); if (!unit) return;
        const row = node('tr'); row.dataset.priceVariant = variant.id; row.dataset.priceStrain = variant.options[0];
        const name = node('td'); const button = node('button', variant.options[variant.options.length - 1]); button.type = 'button'; button.disabled = !variant.available;
        button.addEventListener('click', () => { choose(variant); form.scrollIntoView({ block: 'center', behavior: 'smooth' }); });
        name.append(button); row.append(name, node('td', money(variant.price)), node('td', `${unitMoney(variant.price / unit.count)} / ${unit.unit}`)); table.append(row);
      });
    }
    choose(selected, false); observeSticky();
  }
  window.KPCommerce = Object.freeze({ openDialog, refreshCart, units, money, unitMoney });
})();
